// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "0.0.5/static/js/" + chunkId + "." + "e57111b9" + ".chunk.js";
};